// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SplitCellsOutlinedSvg from "@ant-design/icons-svg/es/asn/SplitCellsOutlined";
import AntdIcon from '../components/AntdIcon';

var SplitCellsOutlined = function SplitCellsOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SplitCellsOutlinedSvg
  }));
};

SplitCellsOutlined.displayName = 'SplitCellsOutlined';
export default React.forwardRef(SplitCellsOutlined);